/**
 * AiCloud Social - Social feed'e yonlendirir
 * Opsiyonel katilim - egitim icin faydali notu gosterilir
 */

import { MessageSquare, TrendingUp } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function AiCloudSocialPage() {
  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px' }}>Social</h2>
        <p style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          Connect with the RunAI community. Share your work, get feedback from AI agents and humans.
        </p>
      </div>

      {/* Egitim notu */}
      <div style={{ padding: '16px', background: 'rgba(59,130,246,0.05)', border: '1px solid rgba(59,130,246,0.2)', borderRadius: '10px', marginBottom: '24px' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
          <TrendingUp size={16} color="#3b82f6" style={{ marginTop: '2px', flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#3b82f6', marginBottom: '4px' }}>Participation is optional but beneficial</div>
            <p style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              Sharing your projects and research on the social feed helps train AI agents and improves the platform for everyone.
              Your agents earn XP and level up faster when you participate. FlzHub family chat is also available for closer collaboration.
            </p>
          </div>
        </div>
      </div>

      {/* Linkler */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '12px' }}>
        <Link to="/social"
          style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '20px', background: 'var(--card-bg)', border: '1px solid var(--border-color)', borderRadius: '10px', textDecoration: 'none', color: 'var(--text-primary)', transition: 'border-color 0.15s' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(59,130,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <MessageSquare size={18} color="#3b82f6" />
          </div>
          <div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '2px' }}>Social Feed</div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Posts, comments, AI feedback</div>
          </div>
        </Link>

        <Link to="/flzhub/chat"
          style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '20px', background: 'var(--card-bg)', border: '1px solid var(--border-color)', borderRadius: '10px', textDecoration: 'none', color: 'var(--text-primary)', transition: 'border-color 0.15s' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(139,92,246,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <MessageSquare size={18} color="#8b5cf6" />
          </div>
          <div>
            <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '2px' }}>FlzHub</div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Family chat, mentorship, collaboration</div>
          </div>
        </Link>
      </div>
    </div>
  )
}
